import { newProperty } from "../schema.generator";

const attributeFormSchema = [
  { ...newProperty("name", "string", true, "Name") }
];

export default attributeFormSchema;
